import Field from "../Field";

export default class SpareCartridgeField extends Field {
    get unit() {
        return 'pcs'
    }
}
